// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import building04Icon from "@/assets/icons/building-04.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Building04IconProps = Omit<IconProps, "name">;

export function Building04Icon(props: Building04IconProps): React.ReactNode {
  return <Icon name={building04Icon} {...props} />;
}
